import { CohortExport, CohortResults } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export function fetchCohortResults(
  context: ApiContext,
  cohortId: string,
  cursor?: string,
  resultId?: string,
  signal?: AbortSignal
) {
  const params = new URLSearchParams()
  if (cursor) params.set("cursor", cursor)
  if (resultId) params.set("result_id", resultId)
  return apiContextFetch<CohortResults>(context, `cohort_results/${cohortId}?${params}`, { signal })
}

export function fetchCohortCsvExport(context: ApiContext, cohortId: string, resultId: string) {
  return apiContextFetch<CohortExport>(context, `cohort_results/${cohortId}/csv_export?result_id=${resultId}`)
}

export function createCohortCsvExport(context: ApiContext, cohortId: string, resultId: string) {
  return apiContextFetch<CohortExport>(context, `cohort_results/${cohortId}/csv_export`, {
    method: "POST",
    body: JSON.stringify({ result_id: resultId }),
  })
}
